module.exports = __webpack_public_path__ + "static/media/IMG_9622.acae811f.JPEG";